import $ from 'jquery';

$(document).ready(function () {
    const $eventListEl = $('.event-insight-main');

    $(function () {
        if ($eventListEl.length > 0) {
            $eventListEl.each(function () {
                eventList($(this));
            });
        }
    });

    const eventList = async (listEl) => {
        const filter = {
            heading: listEl.attr('data-heading'),
            faculties: listEl.attr('data-faculties'),
            showDetail: listEl.attr('data-showdetail'),
            categories: listEl.attr('data-categories'),
            moreLink: listEl.attr('data-morelink'),
            limit: listEl.attr('data-limit'),
            lang: listEl.attr('data-lang'),
            enablePadding: listEl.attr('data-enable-padding'),
        };

        const data = await getEventInsights(filter);
        listEl.html(data.html);
    };

    const getEventInsights = async (filter) => {
        try {
            const response = await fetch(SITE_PARAMS.api_url + '/wp-json/mendelu/v1/event-insight/main', {
                method: 'POST',
                mode: 'cors',
                headers: new Headers({
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify(filter),
            });
            const result = await response.json();
            return result;
        } catch (e) {
            let result = {};
            result.html = '';
            console.log(e);
            return result;
        }
    };
});

export function getEventInsightMain() {

    const $eventListEl = $('.event-insight-main');

    $(function () {
        if ($eventListEl.length > 0) {
            $eventListEl.each(function () {
                eventList($(this));
            });
        }
    });

    const eventList = async (listEl) => {

        const filter = {
            heading: listEl.attr('data-heading'),
            faculties: listEl.attr('data-faculties'),
            showDetail: listEl.attr('data-showdetail'),
            categories: listEl.attr('data-categories'),
            moreLink: listEl.attr('data-morelink'),
            limit: listEl.attr('data-limit'),
            lang: listEl.attr('data-lang'),
            enablePadding: listEl.attr('data-enable-padding'),
        };

        const data = await getEventInsights(filter);
        listEl.html(data.html);
    };

    const getEventInsights = async (filter) => {
        try {
            const response = await fetch(SITE_PARAMS.api_url + '/wp-json/mendelu/v1/event-insight/main', {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify(filter),
            });
            const result = await response.json();
            return result;
        } catch (e) {
            let result = {};
            result.html = '';
            console.log(e);
            return result;
        }
    };
}